export default {
  labels: {
    sold_out: 'Sold out',
  },
};
